import { render, staticRenderFns } from "./index.vue?vue&type=template&id=15b24f82&"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('15b24f82')) {
      api.createRecord('15b24f82', component.options)
    } else {
      api.reload('15b24f82', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=15b24f82&", function () {
      api.rerender('15b24f82', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/chicken-road/index.vue"
export default component.exports